import React from "react";
import CreditCard from '../CreditCard/CreditCard';
import {injectStripe} from 'react-stripe-elements';

class CheckoutActualForm extends React.Component {

    state = {
        formProcessing: false
    };

  handleSubmit = (ev) => {
    // We don't want to let default form submission happen here, which would refresh the page.
    ev.preventDefault();
      this.setFormProcessing(true);

    this.props.stripe.createToken().then(({token}) => {
      if (token === undefined) {
        Sentry.captureMessage('There was an error receiving a new payment method token from stripe.');
      }

      this.submitForm(token);
    });
  };

  submitForm = (stripeToken) => {
    fetch('/new/premium/subscription', {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        stripeToken: stripeToken.id,
        planId: this.getPlan(),
        _token: this.props.csrf.token
      }),
    }).then((response) => {
      response.json().then((json) => {
        var redirectUrl = json.url;
        if (redirectUrl !== undefined) {
          window.location = redirectUrl;
        } else {
          Sentry.captureMessage('There was an error receiving a response from pocket.');
        }
        this.setFormProcessing(false);
      });
    });
  };

  getPlan = () => {
    return document.querySelector('.toggle-yrmth-selected > input').getAttribute('data-planId');
  };

  setFormProcessing = (processing) => {
      this.setState({
          formProcessing: processing
      });
  };

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <h4>purchase.creditcard</h4>
        <div className="form-row">
          <CreditCard />
        </div>
        <br />
        <div className="premium-processing"></div>
        <input type="hidden" name="_token" value={ this.props.csrf.token } />
        <div hidden={!this.state.formProcessing}>Processing Payment</div>
        <button disabled={this.state.formProcessing} type="submit" tabIndex="11" className="btn btn-purchase-premium1">premium.purchase</button>
      </form>
    );
  }
}

//Form content needs to be a separate file so we can export it in a wrapper function.
export default injectStripe(CheckoutActualForm);
